export default "__VITE_ASSET__BfoGDdB0__"